module.exports = __webpack_public_path__ + "img/daichusuorenyuan.84f709b5.png";